vf.enterpriseHotline = (function () {
    'use strict';
    var eventnames = {
        HOVERHOTLINE: 'hoverHotline',
        AFTERCONTENTINJECT: 'afterContentInject',
        CLICKFLYOUTTAB: 'clickFlyoutTab',
        HOVERGUCKGUCK: 'hoverGuckGuck'
    };

    var events = {};

    var timer = null;

    var config = {
        'container': '.list-nav-main',
        'defaultNumber': '0800 503 5022',
        'content': '<li class="item-hotline only-xlrg" style="opacity: 0;"><span class="hotline at-element-click-tracking">Beratung&nbsp;&amp;&nbsp;Bestellung:&nbsp;  <a href="tel:08005035022" id="vo-hotline-number">0800 503 5022</a></span><span class="icon icon-info"></span><span class="hotline-flyout"><b>Kostenlos aus allen Netzen</b><br>Montags - Freitags 8 bis 20 Uhr</span></li>',
        'addMode': 'prepend', //prepend or append
        'addToSelector': '.list-nav-meta-right',
        'hoverSelectorToShowHotlineInfo': 'li.item-hotline'
    };

    function callEventCallbacks(name) {
        var loopEvents = events[name];
        if (!loopEvents) {
            return null;
        }

        for (var i = 0; i < loopEvents.length; i++) {
            var event = loopEvents[i];
            if ('function' === typeof event) {
                event(name);
            }
        }
        return true;
    }

    function on(name, callback) {
        if (!events[name] || 'function' !== typeof callback) {
            return false;
        }
        events[name].push(callback);
        return true;
    }

    function createCallbackObject() {
        for (var key in eventnames) {
            var eventname = eventnames[key];
            events[eventname] = [];
        }
    }

    // function injectHotline() {
    //     $(config.addToSelector, config.container)[config.addMode](config.content);
    //     callEventCallbacks(eventnames.AFTERCONTENTINJECT);
    // }

    function setEvents() {
        $(config.hoverSelectorToShowHotlineInfo, config.container).on('mouseenter mouseleave', function () {
            $(this).toggleClass('nav-display');
        });
    }

    function showHotlineNumber() {
        $('.item-hotline', config.container).css('opacity', 1);
    }

    function showHotlineNumberAfterMatelso() {
        var counter = 0;
        timer = window.setInterval(function () {
            if ('undefined' !== typeof mtls) {
                window.clearInterval(timer);
                showHotlineNumber();
            } else {
                counter++;
                if (15 === counter) {
                    window.clearInterval(timer);
                    showHotlineNumber();
                }
            }
        }, 200);
    }


    function init(configData) {
        createCallbackObject();

        configData = configData || {};
        config = Object.assign(config, configData);

        //injectHotline();
        setEvents();
        showHotlineNumberAfterMatelso();
    }

    function conditionconfig() {
        return {
            'forLayout': 'desktop',
            'prependTo': '.list-nav-meta-right'
        };
    }

    return {
        'init': init,
        'showHotlineNumber': showHotlineNumber,
        'showHotlineNumberAfterMatelso': showHotlineNumberAfterMatelso,
        'on': on,
        'EVENT': eventnames,
        'conditionconfig': conditionconfig
    };
})();
